<template>
  <div>
    <vue-good-table
      theme="view"
      :columns="colunasHistoricos"
      :rows="historicos"
      :row-style-class="'style-dados-inativacao'"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <span
          v-if="props.column.field === 'tipoHistorico'"
          :class="['badge-historico', {'badge-ativo-historico': props.row.tipoHistorico === 'Ativada', 'badge-inativo-historico': props.row.tipoHistorico === 'Inativada'}]"
        >
          {{ props.row.tipoHistorico }}
        </span>
        <span v-else-if="props.column.field === 'motivo'">
          {{ props.row.motivo }}
          <font-awesome-icon
            v-if="props.row.motivo && props.row.observacao"
            class="ml-1"
            color="Dodgerblue"
            :icon="faComment"
            @click="abrirModalObservacao(props.row)"
          />
        </span>
      </template>
      <div slot="emptystate">
        <p style="text-align:center; margin:0">
          Nenhum registro foi encontrado.
        </p>
      </div>
    </vue-good-table>
    <b-modal
      ref="modalObservacao"
      title="Observação"
      size="sm"
      hide-footer
      @hide="limparModal"
    >
      {{ historicoSelecionado.observacao ? historicoSelecionado.observacao : 'Sem observação' }}
    </b-modal>
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.badge-historico {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}

.badge-inativo-historico {
  background-color: transparent;
  color: #ea5455;
  border: 1px solid;
  padding: 0.2rem 0.5rem;
  text-align: center;
}

.badge-ativo-historico {
  background-color: transparent;
  color: #00cc66;
  border: 1px solid;
  padding: 0.2rem 0.5rem;
  text-align: center;
}

.style-dados-inativacao {
  font-size: 14px;
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faComment } from '@fortawesome/free-regular-svg-icons'

export default {
  name: 'TabelaHistoricoInativacao',
  components: {
    VueGoodTable,
    FontAwesomeIcon,
  },
  props: {
    historicos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      faComment,
      colunasHistoricos: [
        {
          label: 'Data',
          field: 'dataCadastro',
          thClass: 'style-dados-inativacao',
        },
        {
          label: 'Ação',
          field: 'tipoHistorico',
          thClass: 'style-dados-inativacao',
        },
        {
          label: 'Motivo',
          field: 'motivo',
          thClass: 'style-dados-inativacao',
        },
        {
          label: 'Usuário',
          field: 'usuario',
          thClass: 'style-dados-inativacao',
        },
      ],
      historicoSelecionado: {},
    }
  },
  methods: {
    abrirModalObservacao(historico) {
      this.historicoSelecionado = historico
      this.$refs.modalObservacao.show()
    },
    limparModal() {
      this.historicoSelecionado = {}
    },
  },
}
</script>
